import React from "react";
import {calculateAge} from "../utils.js"
import {FaLocationPin, FaPersonDress} from "react-icons/fa6";
import {FaCalendar} from "react-icons/fa";
import {useEdgeBuilder} from "../../association-network-context.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import BaseNode from "./base-node.jsx";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";
import CheckHasData from "../check-has-data.jsx";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const Individual = ({data, selected}) => {
    const navigate = navigateHook();
    const {toggleItemsNode} = useEdgeBuilder();

    const icon = (
        <img
            className="m-auto  w-[20px]"
            src={getAssetPath("img/dashboard-svg/sw.individual.svg")}
            alt="image"
        />
    );

    const title = (
        <div className={"w-[97px]"}>
            <p className={"!mb-[2px]"}>
                <b className={"block overflow-hidden whitespace-nowrap text-ellipsis"}>
                    <CheckHasData value={data.name} colorText={"#fff"}/>
                </b>
            </p>
            <p className={"mb-0 text-[6px]"}>
                <CheckHasData value={projectUtils.formatCpfToView(data.cpf)} colorText={"#fff"} />
            </p>
        </div>
    )

    const getDateBirth = () => {
        if (!data.dtBirth) return (<CheckHasData value={data.dtBirth} />)
        return (
            <>
                {calculateAge(data.dtBirth)}
                <span className={"text-[5px]"}> (<CheckHasData value={projectUtils.formatDate(data.dtBirth, 'DD/MM/YYYY')} />)</span>
            </>
        )
    }

    const infoBlock = (
        <div className="p-[3px] text-[7px]">
            {

                toggleItemsNode.individual.age &&
                <div className={"flex items-center mb-1"}>
                    <FaCalendar/>
                    <p className={"ml-1 mb-0 leading-[7px]"} style={{marginTop: "1px"}}>
                        {getDateBirth()}
                    </p>
                </div>
            }
            {
                toggleItemsNode.individual.mother &&
                <div className={"flex items-center"}>
                    <FaPersonDress/>
                    <p className={"ml-1 mb-0 leading-[7px]"}>
                        <CheckHasData value={data.motherName} />
                    </p>
                </div>
            }
            {
                toggleItemsNode.individual.address &&
                <div className={"flex items-center mt-1"}>
                    <FaLocationPin/>
                    <p className={"ml-1 mb-0 leading-[7px]"}>
                        <CheckHasData value={data.address} />
                    </p>
                </div>
            }
        </div>
    );

    const open = () => {
        if (!data.cpf) return;
        const urlDev = `/individuals/form/${data.cpf}`
        
        navigate(urlDev, true);
    }

    return (
        <BaseNode
            icon={icon}
            title={title}
            image={data.relatedPhotoFaceId ? `${API_KEEPER}/ged/attach/${data.relatedPhotoFaceId}` : getAssetPath("img/user.png")}
            infoBlock={infoBlock}
            onSearchConnections={true}
            onExtraAction={open}
            onExtraActionDisabled={!data.cpf}
            showAddConnectionButton={true}
            selected={selected}
            bgHeader={"bg-[#33804E]"}
            bgBody={"bg-[#f5fff9]"}
        />
    );
}

export default Individual;
